module.exports = __webpack_public_path__ + "img/3.155022ca.jpg";